/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { BillingModulesEnum } from './billingModulesEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface BillingLogsJournal { 
    id?: number;
    entity_id?: number;
    entity_uuid?: string;
    org_id?: string;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    created_ts?: Date;
    eventTs?: Date;
    messageLog?: string;
    module?: BillingModulesEnum;
}
export namespace BillingLogsJournal {
}


